import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FieldTypes } from 'app/shared/model/enums';

@Component({
  selector: 'app-business-management-card-mobile',
  templateUrl: './business-management-card-mobile.component.html',
  styleUrl: './business-management-card-mobile.component.scss'
})
export class BusinessManagementCardMobileComponent {
   @Input()
    currentBusiness 
    @Input()
    columns
    @Output()
    cardClick = new EventEmitter();
    fieldTypes = FieldTypes; 
    
    onCardClick() {
      this.cardClick.emit(this.currentBusiness);
    }
}
